(function () {
  window.theme = window.theme || {};

  function parseInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function parseBoolean(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return String(value) === 'true';
  }

  theme.SlideShow = function SlideShow(container) {
    this.container = container;
    this.swiper = null;
    this.init();
  };

  theme.SlideShow.prototype = Object.assign({}, theme.SlideShow.prototype, {
    init: function () {
      if (!this.container || typeof window.Swiper === 'undefined') return;

      // Sections that expose an explicit slider toggle should honor it.
      if (this.container.dataset.sliderEnable === 'false') return;

      var slider = this.container.querySelector('.hero__slider--activation.swiper');
      if (!slider) return;

      // Shopify's theme editor can reload a section without a full page refresh.
      if (slider.swiper && typeof slider.swiper.destroy === 'function') {
        slider.swiper.destroy(true, true);
      }

      var data = this.container.dataset;
      var desktop = parseInteger(data.slidesperview, 1);
      var smallDesktop = parseInteger(
        data.smallDesktopView || data.samlldesktopview,
        desktop
      );
      var tablet = parseInteger(data.showTablet, Math.min(smallDesktop, desktop));
      var mobile = parseInteger(data.showMobile, 1);
      var spaceBetween = parseInteger(
        data.slideshow || data.sliderSpaceBetweeen,
        0
      );
      var autoplayEnabled = parseBoolean(
        data.slideAutoplay || data.sliderAutoplay,
        false
      );
      var autoplayDelay = parseInteger(
        data.autoplayDuration || data.autoplayTime,
        5000
      );
      var loopRequested = parseBoolean(
        data.slideLoop || data.sliderLoop,
        false
      );

      var slides = slider.querySelectorAll('.swiper-wrapper > .swiper-slide');
      var slideCount = slides.length;
      var largestVisibleCount = Math.max(desktop, smallDesktop, tablet, mobile);
      var loopEnabled = loopRequested && slideCount > largestVisibleCount;

      var nextButton = slider.querySelector('.swiper-button-next') || this.container.querySelector('.swiper-button-next');
      var previousButton = slider.querySelector('.swiper-button-prev') || this.container.querySelector('.swiper-button-prev');
      var pagination = slider.querySelector('.swiper-pagination') || this.container.querySelector('.swiper-pagination');

      var options = {
        slidesPerView: mobile,
        spaceBetween: spaceBetween,
        loop: loopEnabled,
        rewind: loopRequested && !loopEnabled,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        speed: 600,
        breakpoints: {
          750: {
            slidesPerView: tablet
          },
          992: {
            slidesPerView: smallDesktop
          },
          1200: {
            slidesPerView: desktop
          }
        }
      };

      if (pagination) {
        options.pagination = {
          el: pagination,
          clickable: true
        };
      }

      if (nextButton && previousButton) {
        options.navigation = {
          nextEl: nextButton,
          prevEl: previousButton
        };
      }

      if (autoplayEnabled && slideCount > 1) {
        options.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      this.swiper = new Swiper(slider, options);
    },

    onUnload: function () {
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  });
})();
